import React, { useEffect, useState } from "react";
import InsightTable from "../../InsightTable";
import { transformResultsToCompProfileData } from "../../../../../services/commonService";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function Finance({ susFinInnoRisk = [], compView }) {
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");

  const [columns, setColumns] = useState([]);
  const [sidebarColumns, setSidebarColumns] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);

  let allMetrics = [];
  useEffect(() => {
    if (compView === "quantitative") {
      allMetrics = [
        // { key: "working_capital_days", label: "Working Capital Days" },
        { key: "notes", label: "Notes" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    } else {
      allMetrics = [
        // { key: "working_capital_days", label: "Working Capital Days" },
        {
          key: "supply_chain_finance_programs",
          label: "Supply Chain Finance Programs",
        },
        { key: "notes", label: "Notes" },
        // { key: "benchmarking_vs_industry", label: "Benchmarking vs Industry" },
        // { key: "forward_outlook", label: "Forward Outlook" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    }
  }, [compView]);

  useEffect(() => {
    const dataArray = Array.isArray(susFinInnoRisk)
      ? susFinInnoRisk
      : [susFinInnoRisk];

    const cleanedData = dataArray.map((item) => {
      const { sustainability, innovation, risks, ...rest } =
        item.response || {};
      return { ...item, response: rest };
    });

    const transformed = transformResultsToCompProfileData(cleanedData);
    setTabData(transformed);

    setTableBelowDescription(
      <ParsedTextWithLinks
        text={susFinInnoRisk?.[0]?.response?.tableComments || ""}
      />
    );
  }, [susFinInnoRisk]);

  const actions = [
    // { type: "conversation", title: "Conversation", onClick: () => {} },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <InsightTable
      title="Finance"
      subtitle=""
      data={tabData}
      metrics={columns}
      rowIdentifier="working_capital_days"
      // belowTableDescription={tableBelowDescription}
      belowTableDescription={""}
      actions={actions}
    />
  );
}

export default Finance;

// working_capital_days, supply_chain_finance_programs, notes, benchmarking_vs_industry, forward_outlook
